import { render, staticRenderFns } from "./income-list.vue?vue&type=template&id=31f9e00d&scoped=true&"
import script from "./income-list.vue?vue&type=script&lang=js&"
export * from "./income-list.vue?vue&type=script&lang=js&"
import style0 from "./income-list.vue?vue&type=style&index=0&id=31f9e00d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9e00d",
  null
  
)

export default component.exports